import { KS_CONTACT, kshetrapalDeveloper, buildFaqs } from "./developer";

const G = "https://shreekshetrapal.in/storage/2024/11";

const epitome = {
    slug: "shree-kshetrapal-epitome",
    visibility: "public",
    name: "Shree Kshetrapal Epitome",
    tagline: "Premium Commercial Destination",
    category: "commercial",
    typeLabel: "Commercial",
    areaLabel: "1,15,794 sq.ft.",
    city: "Bhuj",
    citySlug: "bhuj",
    locality: "Mundra Road",
    status: "Under Construction",
    priceLabel: null,
    developer: { name: "Shree Kshetrapal Infra LLP" },
    whatsapp: KS_CONTACT.whatsapp,
    phone: KS_CONTACT.phone,
    phoneDisplay: KS_CONTACT.phoneDisplay,
    coverImage: "https://shreekshetrapal.in/storage/2025/09/epitome.webp",
    hero: {
        image: "https://shreekshetrapal.in/storage/2025/09/epitome.webp",
        overline: "Commercial · Mundra Road, Bhuj",
        lines: ["Shree Kshetrapal", "Epitome"],
        sub: "A premium commercial development in Bhuj, Kutch — a modern hub for retail outlets, corporate offices, fine dining and boutique shops.",
    },
    sections: [
        {
            type: "overview",
            overline: "Overview",
            title: "Bhuj's new address for business.",
            paragraphs: [
                "Shree Kshetrapal Epitome is a premium commercial real-estate development located in Bhuj, Kutch, offering a blend of modern architecture and state-of-the-art facilities.",
                "The project is designed to be a hub for retail outlets, corporate offices, fine dining and boutique shops — catering to young entrepreneurs, creative professionals and emerging brands.",
            ],
            facts: [
                { label: "Status", value: "Under Construction" },
                { label: "Type", value: "Commercial" },
                { label: "Total Area", value: "1,15,794 sq.ft." },
                {
                    label: "Address",
                    value: "Opp. Leva Patel Hospital, Mundra Road, Bhuj–Kutch",
                },
            ],
        },
        {
            type: "highlights",
            overline: "Highlights",
            title: "Why Epitome works for business.",
            items: [
                {
                    title: "Retail · Offices · Dining",
                    text: "A planned hub for retail outlets, corporate offices, fine dining and boutique shops.",
                },
                {
                    title: "Mundra Road frontage",
                    text: "Positioned opposite Leva Patel Hospital on one of Bhuj's key corridors.",
                },
                {
                    title: "1,15,794 sq.ft.",
                    text: "A large-format commercial development, currently under construction.",
                },
                {
                    title: "4 dedicated elevators",
                    text: "Multiple elevators keep movement smooth for visitors and tenants.",
                },
                {
                    title: "Lockable shop spaces",
                    text: "Secure, lockable units give every business its own protected space.",
                },
                {
                    title: "Separate entry & exit",
                    text: "Planned circulation with dedicated entry and exit points.",
                },
            ],
        },
        {
            type: "amenities",
            overline: "Amenities",
            title: "Built for a seamless business day.",
            note: "Amenity list as published by the developer.",
            items: [
                { icon: "Video", name: "CCTV Surveillance", desc: "Camera coverage across the development." },
                { icon: "ShieldCheck", name: "24×7 Security", desc: "Round-the-clock on-site security." },
                { icon: "Briefcase", name: "Fully Operational Workspace", desc: "Ready environment for working businesses." },
                { icon: "DoorOpen", name: "Separate Entry & Exit", desc: "Dedicated circulation in and out." },
                { icon: "ArrowUpDown", name: "4 Dedicated Elevators", desc: "Fast vertical movement across floors." },
                { icon: "MoveHorizontal", name: "Wide Corridors", desc: "Generous common passages." },
                { icon: "Lock", name: "Lockable Shop Spaces", desc: "Secure units for every owner." },
                { icon: "Baby", name: "Children Play Area", desc: "A dedicated space for young visitors." },
            ],
        },
        {
            type: "plans",
            overline: "Floor Plans",
            title: "Three floors of commerce.",
            note: "Plans as published by the developer. Tap any plan to view it full size.",
            items: [
                {
                    label: "Ground Floor",
                    image: "https://shreekshetrapal.in/storage/2024/10/ground-floor-epitome.png",
                },
                {
                    label: "First Floor",
                    image: "https://shreekshetrapal.in/storage/2024/10/first-floor-epitome.png",
                },
                {
                    label: "Second Floor",
                    image: "https://shreekshetrapal.in/storage/2024/10/second-floor-epitome.png",
                },
            ],
        },
        {
            type: "gallery",
            overline: "Gallery",
            title: "Epitome in renders.",
            caption: "Imagery courtesy of Shree Kshetrapal Infra LLP.",
            images: [
                { src: `${G}/epitom__08.jpg`, caption: "Elevation render", span: 8 },
                { src: `${G}/epitom__02.jpg`, caption: "Architectural render", span: 4 },
                { src: `${G}/epitom__01.jpg`, caption: "Architectural render", span: 4 },
                { src: `${G}/epitom__06.jpg`, caption: "Architectural render", span: 4 },
                { src: `${G}/epitom__010.jpg`, caption: "Architectural render", span: 4 },
                { src: `${G}/epitom__07.jpg`, caption: "Architectural render", span: 8 },
                { src: `${G}/epitom__09.jpg`, caption: "Architectural render", span: 4 },
                { src: `${G}/epitom__05.jpg`, caption: "Architectural render", span: 4 },
                { src: `${G}/epitom__04.jpg`, caption: "Architectural render", span: 4 },
                { src: `${G}/epitom__03.jpg`, caption: "Architectural render", span: 4 },
            ],
        },
        {
            type: "location",
            overline: "Location",
            title: "Mundra Road, Bhuj.",
            image: "https://shreekshetrapal.in/storage/2024/10/KSPL-All-Booklet-Keyplan_page-0001.jpg",
            addressLines: ["Opp. Leva Patel Hospital,", "Mundra Road, Bhuj – Kutch, Gujarat"],
            mapUrl: "https://maps.app.goo.gl/hVrYjSDQjq6Xid6JA",
            landmarks: [
                { name: "Jubilee Ground", detail: "1.1 km" },
                { name: "Bhuj Bus Station", detail: "2.5 km" },
                { name: "Bhuj Railway Station", detail: "4.2 km" },
                { name: "Bhuj Airport", detail: "8.8 km" },
            ],
            note: "Distances as published by the developer. Keyplan image courtesy of the developer.",
        },
        { type: "developer", ...kshetrapalDeveloper },
        buildFaqs("Shree Kshetrapal Epitome"),
        {
            type: "cta",
            overline: "Connect Directly",
            title: "Talk to the Epitome team.",
            text: "Ask for current pricing, unit availability, payment plans or a site visit — your message goes straight to Shree Kshetrapal Infra LLP. No brokers in between.",
            brochureUrl:
                "https://shreekshetrapal.in/wp-content/uploads/2025/06/EPITOME.pdf",
        },
    ],
};

export default epitome;
